<template>
    <v-container class="totals">
        <v-row
            class="totals__description primary__text font-weight-bold pl-3 pt-4"
            justify="start">
            {{ description }}
        </v-row>
        <v-row justify="start">
            <v-hover
                :key="race.name"
                v-for="race in totals"
                v-slot="{ hover }">
                <v-col
                    cols="12"
                    :sm="smNumCols"
                    :md="mdNumCols">
                    <v-card
                        :class="useHoverEffect(hover, race) ? `totals__${race.color}--active` : `totals__${race.color}`"
                        flat
                        :to="isClickable ? { name: race.narrative } : ''"
                        outlined>
                        <p class="totals__title text-center font-weight-bold">
                            {{ !!race.title ? race.title : race.name }}
                        </p>
                        <p class="totals__text text-center font-weight-bold">
                            {{ formatBigNumber(race.count, race.isPercent) }}
                        </p>
                    </v-card>
                </v-col>
            </v-hover>
        </v-row>
    </v-container>
</template>

<script>
import NumberUtilities from "../../utilities/NumberUtilities";

export default {
    name: "totals",
    props: {
        isClickable: Boolean,
        description: String,
        small: Boolean,
        totals: Array
    },
    mixins: [
        NumberUtilities
    ],
    computed: {
        smNumCols() {
            let numCols = 4;
            if (this.small) {
                numCols = 6;
            }

            if (this.numStats % (12/numCols) === 0) {
                return numCols;
            }
            return 12/this.gcd(12, this.numStats);
        },
        mdNumCols() {
            let numCols = 4;
            if (this.small) {
                numCols = 3;
            }
            if (this.numStats % (12/numCols) === 0) {
                return numCols;
            }

            return 12/this.gcd(12, this.numStats);
        },
        numStats() {
            return this.totals.length;
        },
        selectedStat() {
            return this.$route.name;
        },
    },
    methods: {
        useHoverEffect(hover, race) {
            return this.isClickable && (hover || this.selectedStat === race.narrative);
        },
        // greatest common divisor
        gcd(a, b) {
            if (b) {
                return this.gcd(b, a % b);
            } else {
                return Math.abs(a);
            }
        }
    }
}
</script>

<style lang="scss">
@import '../../styles/_variables.scss';
@import "../../styles/_mixins.scss";

.totals {
    &__description {
        font-size: 16px;
        @media screen and (min-width: $md) {
            font-size: 18px;
        }
        @media screen and (min-width: $xl) {
            font-size: 24px;
        }
    }
    &__title {
        font-size: 16px;
        padding: 10px 10px 10px 10px;
        @media screen and (min-width: $md) {
            padding: 10px 10px 10px 10px;
            font-size: 18px!important;
        }
        @media screen and (min-width: $xl) {
            padding: 10px 10px 10px 10px;
            font-size: 24px!important;
        }
    }
    &__text {
        font-size: 42px;
        padding: 0px 10px 10px 10px;
        @media screen and (min-width: $md) {
            padding: 0px 10px 10px 10px;
            font-size: 50px;
        }
        @media screen and (min-width: $xl) {
            padding: 0px 10px 10px 10px;
            font-size: 62px;
        }
    }

    &__aapi{
        @include totalCard($aapi, $aapiLighten2)
    }
    &__black{
        @include totalCard($black, $blackLighten2)
    }
    &__flipped{
        @include totalCard($flipped, $flippedLighten2)
    }
    &__gotv{
        @include totalCard($gotv, $gotvLighten2)
    }
    &__latino{
        @include totalCard($latino, $latinoLighten2)
    }
    &__lgbtq{
        @include totalCard($lgbtq, $lgbtqLighten2)
    }
    &__native_american{
        @include totalCard($nativeAmerican, $nativeAmericanLighten2)
    }
    &__new{
        @include totalCard($new, $newLighten2)
    }
    &__poc{
        @include totalCard($poc, $pocLighten2)
    }
    &__primary{
        @include totalCard($primary, $primaryLighten2)
    }
    &__technology {
        @include totalCard($technology, $technologyLighten2)
    }
    &__women{
        @include totalCard($women, $womenLighten2)
    }
}
</style>